import 'whatwg-fetch';
import { GET } from './constants';
import { ContractBaseUrl, NetworkBaseUrl } from './utils';

const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.status);
  }
  return response;
};

const doFetch = async (params, network) => {
  let url;
  if (network) {
    url = `${NetworkBaseUrl}/${params.api}`;
  } else {
    url = `${ContractBaseUrl}/${params.api}`;
  }

  const header = new Headers();
  if (params.method === GET) {
    header.set('Content-Type', 'text/plain; charset=utf-8');
    header.append('pragma', 'no-cache');
    header.append('cache-control', 'no-cache');
    if (params.header) {
      header.append('data', JSON.stringify(params.header));
    }
  } else {
    header.set('Content-Type', 'application/json');
  }

  const fetchData = {
    method: params.method,
    headers: header,
    body: params.body ? JSON.stringify(params.body) : undefined,
  };

  try {
    let response = await fetch(url, fetchData);
    return handleErrors(response).json();
  } catch (e) {
    throw Error(e);
  }
};

export default doFetch;



// WEBPACK FOOTER //
// ./src/api/fetch.js